import React from 'react';

import {
  AuthAccessPage,
  CompanyProfilePage,
  ConfirmUserDataPage,
  DraftsPage,
  HomePage,
  IntegrationAuthPage,
  LeadDetailPage,
  ListingReportPage,
  ListingReportSetupPage,
  MembersProfilePage,
  NotFoundPage,
  OfferDetailsPage,
  OffersPage,
  OperationAreasPage,
  PhotosPage,
  PosReportPage,
  PricePerformancePage,
  PropertyPage,
  RegistrationPage,
  SearchPage,
  StatusPage,
  VisitsPage,
} from './pages/ReferencePages';

const parseLeadParams = (pathname, params = {}) => {
  const parts = pathname.split('/').filter(Boolean);
  return {
    ...params,
    leadUuid: parts[0],
    leadNumber: parts[1],
    businessContext: parts[2],
  };
};

export function renderContent(pathname, params = {}) {
  if (pathname === '/portfolio-manager') return <HomePage />;
  if (pathname === '/status' || pathname.startsWith('/status/')) {
    return <StatusPage params={params} pathname={pathname} />;
  }
  if (pathname.startsWith('/house-registration')) {
    const section =
      params.draftSection ||
      (pathname.endsWith('/success') ? 'success' : pathname.split('/').filter(Boolean)[1]);
    return <RegistrationPage section={section} />;
  }
  if (pathname.startsWith('/drafts')) {
    const section = params.draftSection || pathname.split('/').filter(Boolean)[1] || 'ongoing';
    return <DraftsPage section={section} />;
  }
  if (pathname.startsWith('/photos')) return <PhotosPage />;
  if (pathname.startsWith('/property')) {
    return <PropertyPage params={params} pathname={pathname} />;
  }
  if (pathname.startsWith('/search')) {
    return <SearchPage params={params} pathname={pathname} />;
  }
  if (pathname.startsWith('/visits')) return <VisitsPage />;
  if (pathname.startsWith('/rent-offers')) {
    return <OffersPage kind="rent" params={params} pathname={pathname} />;
  }
  if (pathname.startsWith('/sale-offers')) {
    return <OffersPage kind="sale" params={params} pathname={pathname} />;
  }
  if (pathname.startsWith('/rent-offer')) {
    return <OfferDetailsPage kind="rent" params={params} pathname={pathname} />;
  }
  if (pathname.startsWith('/sale-offer')) {
    return <OfferDetailsPage kind="sale" params={params} pathname={pathname} />;
  }
  if (pathname.startsWith('/price-calculator/results')) {
    return <PricePerformancePage result="insufficient" />;
  }
  if (pathname.startsWith('/price-calculator') || pathname.startsWith('/pricing-report')) {
    return (
      <PricePerformancePage
        result={pathname.startsWith('/pricing-report')}
      />
    );
  }
  if (pathname.startsWith('/listing-performance/report-setup')) {
    return <ListingReportSetupPage />;
  }
  if (pathname.startsWith('/listing-performance/report/')) {
    return <ListingReportPage />;
  }
  if (pathname.startsWith('/reports/pos')) return <PosReportPage />;
  if (pathname.startsWith('/listing-performance')) {
    return <PricePerformancePage mode="performance" />;
  }
  if (pathname.startsWith('/company-profile')) return <CompanyProfilePage />;
  if (pathname.startsWith('/members')) return <MembersProfilePage mode="members" />;
  if (pathname.startsWith('/operation-areas')) return <OperationAreasPage />;
  if (pathname.startsWith('/user-profile')) return <MembersProfilePage mode="user" />;
  if (pathname.startsWith('/integration')) return <IntegrationAuthPage mode="integration" />;
  if (pathname.startsWith('/confirm-user-data')) return <ConfirmUserDataPage />;
  if (pathname.startsWith('/profile-conflict/unsuported')) {
    return <IntegrationAuthPage mode="unsupported" />;
  }
  if (pathname.startsWith('/profile-conflict')) return <IntegrationAuthPage mode="conflict" />;
  if (pathname.startsWith('/first-login')) return <AuthAccessPage mode="first-login" />;
  if (pathname.startsWith('/first-access')) return <AuthAccessPage mode="first-access" />;
  if (pathname.startsWith('/reset-password')) return <AuthAccessPage mode="reset-password" />;
  if (pathname.startsWith('/create-new-password')) return <AuthAccessPage mode="new-password" />;
  if (pathname.startsWith('/esqueci-minha-senha')) return <AuthAccessPage mode="forgot-password" />;
  if (pathname.startsWith('/nova-senha')) return <AuthAccessPage mode="new-password" />;
  if (pathname.startsWith('/lead-')) {
    return <LeadDetailPage params={parseLeadParams(pathname, params)} />;
  }
  return <NotFoundPage pathname={pathname} />;
}
